import { render } from "./MdTableThead.vue?vue&type=template&id=2b18c8e8"
import script from "./MdTableThead.vue?vue&type=script&lang=js"
export * from "./MdTableThead.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__